export default __webpack_public_path__ + "static/media/profile.82be9dbe.png";